import { useNavigate } from 'react-router-dom'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, } from '@mui/material'
import { useNotification } from '../../context/NotificationContext'
import PageService from '../../services/PageService'

const RegenerateTestCaseConfirmationModal = ({
  testCase,
  regenerateOpen,
  setRegenerateOpen
}) => {

  const showNotification = useNotification()
  const navigate = useNavigate()

  const handleRegenerateTestCase = async () => {
    showNotification('Test case regenerating has started', 'info', 'Learn more', navigate)
    try {
      await PageService.regenerateTestCasesById(testCase?.id)
      navigate(`/pages/${testCase.pageId}`, { state: { activeTab: '3' } })
    } catch (error) {
      console.log(error)
    }
  }

  const handleCloseDeleteDialog = () => {
    setRegenerateOpen(false)
  }

  return (
    <Dialog open={regenerateOpen} onClose={handleCloseDeleteDialog}>
      <Box className="generateTestCasesModal">
        <DialogTitle className="generateTestCasesModalTitle">
          Confirm Regenerate Test Case
        </DialogTitle>
        <DialogContent className="generateTestCasesModalContent">
          <Typography variant='body1' mb={2}>
            Please confirm that you want to regenerate test case. Your existing tests will be saved, and new one will be generated.
          </Typography>
        </DialogContent>
        <DialogActions className="generateTestCasesModalActions">
          <Button className="generateTestCasesModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            CANCEL
          </Button>
          <Button className="generateTestCasesModalButton" onClick={handleRegenerateTestCase} color="secondary" variant="contained" autoFocus>
            CONFIRM
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default RegenerateTestCaseConfirmationModal